import { ToggleButton, ToggleButtonProps, Tooltip } from "@mui/material";
import React from "react";

interface IAppToggleButtonProps extends ToggleButtonProps {
    tooltip?: string
}

export const AppToggleButton = (props: IAppToggleButtonProps) => {
    const buttonElement = <ToggleButton {...props}>{props.children}</ToggleButton>;

    if (props.tooltip) {
        return (
            <Tooltip title={props.tooltip}>
                <span>
                    {buttonElement}
                </span>
            </Tooltip>
        );
    }

    return (buttonElement);
};